export const getImgUrl = (name)=>{
    return process.env.PUBLIC_URL+"/img/"+name
  }